export default "__VITE_ASSET__b72ed2b6__"